import React, { forwardRef, useState } from "react";
import { ChevronsUpDown, Package, Scale } from "lucide-react";

import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../../../components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "../../../components/ui/popover";
import { numero } from "../lib/numeros";
import { quantidade, sigla } from "../lib/unidades";

function Conversao({ ing }) {
  const pacote = Number(ing.units_per_package) || 0;
  const peso = Number(ing.unit_weight) || 0;
  if (String(ing.unit).toLowerCase() === "un" && pacote > 0) {
    return <span className="inline-flex items-center gap-1 text-[11px] px-1.5 py-0.5 rounded bg-amber-500/15 text-amber-700 dark:text-amber-300"><Package className="w-3 h-3" />pacote {numero(pacote, 3, { minimo: 0 })} un</span>;
  }
  if (peso > 0) {
    return <span className="inline-flex items-center gap-1 text-[11px] px-1.5 py-0.5 rounded bg-sky-500/15 text-sky-700 dark:text-sky-300"><Scale className="w-3 h-3" />1 un = {numero(peso, 3)} kg</span>;
  }
  return null;
}

const sem = (t) => String(t || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

const SeletorIngrediente = forwardRef(function SeletorIngrediente({ ingredientes, ing, aoEscolher }, ref) {
  const [aberto, setAberto] = useState(false);
  return (
    <div>
      <span className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">Ingrediente</span>
      <Popover open={aberto} onOpenChange={setAberto}>
        <PopoverTrigger asChild>
          <button ref={ref} type="button" role="combobox" aria-expanded={aberto} data-e2e="seletor-ingrediente"
            className="mt-1 w-full min-h-12 rounded-lg border bg-background px-3 py-2 flex items-center justify-between gap-2 text-left hover:border-primary/50 focus:outline-none focus:ring-2 focus:ring-ring/40">
            {ing ? (
              <span className="min-w-0">
                <span className="block font-semibold truncate">{ing.name}</span>
                <span className="flex flex-wrap items-center gap-1.5 mt-0.5 text-xs text-muted-foreground">
                  estoque em {sigla(ing.unit)} <Conversao ing={ing} />
                </span>
              </span>
            ) : <span className="text-muted-foreground">Busque pelo nome ou código…</span>}
            <ChevronsUpDown className="w-4 h-4 shrink-0 opacity-50" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-[var(--radix-popover-trigger-width)] min-w-[300px] p-0" align="start">
          <Command filter={(valor, busca) => (sem(valor).includes(sem(busca)) ? 1 : 0)}>
            <CommandInput placeholder="Buscar ingrediente…" data-e2e="busca-ingrediente" />
            <CommandList className="max-h-80">
              <CommandEmpty>Nenhum ingrediente encontrado.</CommandEmpty>
              <CommandGroup>
                {ingredientes.map((i) => (
                  <CommandItem key={i.id} value={`${i.name} ${i.code || ""} ${i.id}`} onSelect={() => { aoEscolher(i.id); setAberto(false); }}>
                    <div className="flex w-full items-center justify-between gap-2">
                      <div className="min-w-0">
                        <div className="truncate font-medium">{i.name}</div>
                        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
                          {i.code ? `#${i.code} · ` : ""}em estoque {quantidade(i.stock_quantity, i.unit)} <Conversao ing={i} />
                        </div>
                      </div>
                    </div>
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  );
});

export default SeletorIngrediente;
